"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterIcon = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const AdvancedFilterDataSelectorIds_1 = require("../helpers/AdvancedFilterDataSelectorIds");
const Icon = styled_components_1.default.svg `
    margin: auto;
    path {
        fill: ${({ theme }) => theme.colorControlIcon};
    }
`;
const FilterIcon = () => (react_1.default.createElement(Icon, { viewBox: "0 0 32 32", "data-selector-id": AdvancedFilterDataSelectorIds_1.AdvancedFilterDataSelectorIds.filterIcon },
    react_1.default.createElement("path", { d: "M.08.28l12.38 11.33v20.11l7.04-5.25V11.61h.03L31.92.28H.08z" })));
exports.FilterIcon = FilterIcon;
//# sourceMappingURL=FilterIcon.js.map